// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1iy9T","title":"Images90_title__15KC4","images":"Images90_images__1LAth"};